import React, { useState, useMemo } from 'react';
import './BrowsePage.css';

const categories = [
  'Natural Stone',
  'Wooden Flooring',
  'Lighting',
  'Ceramic Tiles',
  'Upholstery',
  'Wallpaper',
  'Hardware'
];

const materials = [
  {
    id: 1,
    category: 'Natural Stone',
    name: 'Calacatto Gold Marble',
    brand: 'Artisindustry',
    materialType: 'Marble',
    priceValue: 145,
    price: '₹145 sqm',
    image:
      'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=800&h=600&fit=crop'
  },
  {
    id: 2,
    category: 'Flooring',
    name: 'Streaked Oak Plank',
    brand: 'Koris Sweden',
    materialType: 'Porcelain',
    priceValue: 89,
    price: '₹89 sqm',
    image:
      'https://images.unsplash.com/photo-1501045661006-fcebe0257c3f?w=800&h=600&fit=crop'
  },
  {
    id: 3,
    category: 'Concrete',
    name: 'Concrete Grey XL',
    brand: 'Polystone',
    materialType: 'Travertine',
    priceValue: 52,
    price: '₹52 sqm',
    image:
      'https://images.unsplash.com/photo-1531297484001-80022131f5a1?w=800&h=600&fit=crop'
  },
  {
    id: 4,
    category: 'Mosaic',
    name: 'Venetian Terrazzo',
    brand: 'Agiletech',
    materialType: 'Quartzite',
    priceValue: 110,
    price: '₹110 sqm',
    image:
      'https://images.unsplash.com/photo-1531297484001-80022131f5a1?w=800&h=600&fit=crop'
  },
  {
    id: 5,
    category: 'Lighting',
    name: 'Aura Brass Sconce',
    brand: 'Prism',
    materialType: 'Porcelain',
    priceValue: 420,
    price: '₹420 sqm',
    image:
      'https://images.unsplash.com/photo-1545239351-1141bd82e8a6?w=800&h=600&fit=crop'
  },
  {
    id: 6,
    category: 'Wallcovering',
    name: 'Silk Weave Navy',
    brand: 'Philly Jeffers',
    materialType: 'Marble',
    priceValue: 75,
    price: '₹75 sqm',
    image:
      'https://images.unsplash.com/photo-1523755231516-e43fd2e8dca5?w=800&h=600&fit=crop'
  }
];

const materialTypes = ['Porcelain', 'Marble', 'Travertine', 'Quartzite'];

const BrowsePage = () => {
  const allBrands = useMemo(
    () => Array.from(new Set(materials.map((m) => m.brand))),
    []
  );

  const [activeCategory, setActiveCategory] = useState('All');
  const [selectedMaterials, setSelectedMaterials] = useState(materialTypes);
  const [selectedBrands, setSelectedBrands] = useState(allBrands);
  const [maxPrice, setMaxPrice] = useState(500);

  const toggleMaterial = (type) => {
    setSelectedMaterials((prev) =>
      prev.includes(type) ? prev.filter((t) => t !== type) : [...prev, type]
    );
  };

  const toggleBrand = (brand) => {
    setSelectedBrands((prev) =>
      prev.includes(brand) ? prev.filter((b) => b !== brand) : [...prev, brand]
    );
  };

  const filteredMaterials = useMemo(
    () =>
      materials.filter((item) => {
        if (activeCategory !== 'All' && item.category !== activeCategory) {
          return false;
        }
        if (
          selectedMaterials.length &&
          !selectedMaterials.includes(item.materialType)
        ) {
          return false;
        }
        if (selectedBrands.length && !selectedBrands.includes(item.brand)) {
          return false;
        }
        if (item.priceValue > maxPrice) {
          return false;
        }
        return true;
      }),
    [activeCategory, selectedMaterials, selectedBrands, maxPrice]
  );

  return (
    <section className="browse-page">
      <div className="browse-inner">
        <header className="browse-header">
          <h1 className="browse-title">Browse by Category</h1>
          <div className="browse-category-row">
            {categories.map((cat, index) => (
              <button
                key={cat}
                type="button"
                className={`browse-category-pill ${
                  activeCategory === cat ? 'is-active' : ''
                }`}
                onClick={() =>
                  setActiveCategory((prev) => (prev === cat ? 'All' : cat))
                }
              >
                <span className="browse-category-thumb" />
                <span className="browse-category-label">{cat}</span>
              </button>
            ))}
          </div>
        </header>

        <div className="browse-layout">
          <aside className="browse-filters">
            <div className="browse-filters-header">
              <h2>Filters</h2>
              <span className="browse-filters-date">April 14</span>
            </div>
            <div className="browse-filter-group">
              <h3>Material</h3>
              {materialTypes.map((type) => (
                <label key={type}>
                  <input
                    type="checkbox"
                    checked={selectedMaterials.includes(type)}
                    onChange={() => toggleMaterial(type)}
                  />{' '}
                  {type}
                </label>
              ))}
            </div>

            <div className="browse-filter-group">
              <h3>Price Range</h3>
              <div className="browse-price-row">
                <span>₹0</span>
                <span>₹{maxPrice}</span>
              </div>
              <input
                type="range"
                min="0"
                max="500"
                value={maxPrice}
                onChange={(e) => setMaxPrice(Number(e.target.value))}
              />
            </div>

            <div className="browse-filter-group">
              <h3>Brand</h3>
              {allBrands.map((brand) => (
                <label key={brand}>
                  <input
                    type="checkbox"
                    checked={selectedBrands.includes(brand)}
                    onChange={() => toggleBrand(brand)}
                  />{' '}
                  {brand}
                </label>
              ))}
            </div>

            <button type="button" className="browse-apply-btn">
              Apply Filters
            </button>
          </aside>

          <main className="browse-main">
            <div className="browse-toolbar">
              <p className="browse-count">
                Showing <strong>{filteredMaterials.length}</strong> materials
              </p>
              <div className="browse-sort">
                <label htmlFor="sort-select">Sort by</label>
                <select id="sort-select">
                  <option>Newest Arrivals</option>
                  <option>Price: Low to High</option>
                  <option>Price: High to Low</option>
                </select>
              </div>
            </div>

            <div className="browse-grid">
              {filteredMaterials.map((item) => (
                <article key={item.id} className="browse-card">
                  <div className="browse-card-image-wrap">
                    <img
                      src={item.image}
                      alt={item.name}
                      className="browse-card-image"
                    />
                  </div>
                  <div className="browse-card-body">
                    <span className="browse-card-category">
                      {item.category}
                    </span>
                    <h3 className="browse-card-title">{item.name}</h3>
                    <p className="browse-card-brand">By {item.brand}</p>
                  </div>
                  <div className="browse-card-footer">
                    <span className="browse-card-price">{item.price}</span>
                    <button type="button" className="browse-card-link">
                      View Details
                    </button>
                  </div>
                </article>
              ))}
            </div>

            <div className="browse-pagination">
              <button type="button" className="page-btn">
                {'<'}
              </button>
              <button type="button" className="page-btn">
                1
              </button>
              <button type="button" className="page-btn is-active">
                2
              </button>
              <button type="button" className="page-btn">
                3
              </button>
              <button type="button" className="page-btn">
                {'>'}
              </button>
            </div>
          </main>
        </div>
      </div>
    </section>
  );
};

export default BrowsePage;

